import React from "react";

export default function Benefits({ benefits }) {
  return (
    <div className="bg-gray-50 py-5">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-5">Key Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-[#e9eaeb] p-6 rounded-lg shadow-md hover:translate-y-[-10px] transition-transform duration-300 ease-in-out"
            >
              <i className="text-5xl text-[#a27b5c] my-3 font-bold">
                0{index + 1}
              </i>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
